<template>
	<el-date-picker
		:id="id == null ? prop : id"
		v-model="localModelValue"
		:dir="dir"
		@change="(value) => emitEvent('change', value)"
		type="date"
		value-format="YYYY-MM-DD"
		:label="ariaLabel"
		:disabled="disabled"
		:readonly="readonly"
		:placeholder="placeholder"
		:size="size"
		:autofocus="autofocus"
		class="w-100"
		:disabled-date="disabledDatesAttr"
		popper-class="modal-popper"
	/>
</template>
<script lang="ts">
import { computed, defineComponent } from "vue";

import * as generalMethods from "@/core/mixins/general_methods";
import * as customValidation from "@/core/mixins/custom_validation";

export default defineComponent({
	name: "umt-element-plus-input-core",
	props: {
		id: { type: String, default: null },
		label: { type: String, default: null },
		prop: { type: String, default: null },
		modelValue: {},
		dir: { type: String, default: null },
		ariaLabel: { type: String, default: null },
		disabled: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		placeholder: { type: String, default: null },
		size: { type: String, default: "default" },
		autofocus: { type: Boolean, default: false },
		disabledDates: { type: Number, default: null },
	},
	setup(props, { emit }) {
		const localModelValue = computed({
			get() {
				return props.modelValue;
			},
			set(newValue) {
				emit("update:modelValue", newValue);
			},
		});

		const disabledDatesAttr = computed(() => {
			if (generalMethods.valueExist(props.disabledDates)) {
				if (props.disabledDates == generalMethods.DISABLE_PREVIOUS_DATES) {
					return generalMethods.disableIncomingDays;
				}
			}

			return null;
		});

		const emitEvent = (event, value) => {
			emit(event, value);
		};

		return {
			generalMethods,
			customValidation,

			localModelValue,

			disabledDatesAttr,

			emitEvent,
		};
	},
});
</script>
